<template>
<div>

    <v-card v-for="(room,index_room) in availability.rooms" :key="room.id" class="ma-2" outlined>

        <v-card-title class="text-capitalize">
            <span>
                {{room.room.name}}
                <span class="overline">({{room.room_id}})</span>
            </span>
            <v-spacer />
            <!-- <v-chip label :color="room.available == 0 ? 'error' : 'success'">
                <v-icon small class="mr-2">home</v-icon>
                Disponibilitate: {{room.available}}
            </v-chip> -->
        </v-card-title>

        <v-divider class="mx-4" />
        <v-row no-gutters>
            <v-col cols="12" md="4">
                <v-card flat>
                    <v-card-text>
                        <v-img :src="image" />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-divider vertical class="my-4" />
            <v-col class="pa-2">
                <v-card class="my-2" v-for="(rate,index_rate) in room.prices">
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col cols="8" class="text-left pa-0 title text-capitalize font-weight-light">
                                {{rate.rate.name}}
                                <span class="overline">({{rate.rate_id}})</span>
                            </v-col>
                            <v-col cols="4" class="text-right pa-0">
                                <im-price :font-size="20" :price="rate.price" :currency="rate.currency" />
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row no-gutters>
                            <v-col cols="6" class="text-left body-2">
                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <div class="" v-if="rate.occupancy">
                                            <v-row no-gutters v-if="rate.occupancy.adults === 1">
                                                <v-icon class="mr-2" small>person</v-icon>
                                                Capacitate de {{ rate.occupancy.adults }} adult
                                            </v-row>
                                            <v-row no-gutters v-else>
                                                <v-icon class="mr-2" small>people_alt</v-icon>
                                                <span>Capacitate de {{ rate.occupancy.adults }} adulți</span>
                                                <span v-if="rate.occupancy.infants" class="px-1">{{rate.occupancy.infants}} infanti</span>
                                                <span v-if="rate.occupancy.children" class="px-1">{{rate.occupancy.children}} copii</span>
                                                <span v-if="rate.occupancy.teens" class="px-1">{{rate.occupancy.teens}} adolescenti</span>
                                                <span>.</span>
                                            </v-row>
                                        </div>
                                        <div class="" v-else>
                                            Capacitate default de 2 adulti
                                        </div>

                                        <v-row no-gutters v-if="rate.rate.meals.includes('all-inclusive')">
                                            <v-icon class="mr-2" small>restaurant</v-icon>
                                            All Inclusive
                                        </v-row>
                                        <v-row no-gutters v-if="rate.rate.meals.includes('breakfast')">
                                            <v-icon class="mr-2" small>local_cafe</v-icon>
                                            Micul dejun inclus in preț.
                                        </v-row>
                                        <v-row no-gutters v-if="rate.rate.meals.includes('lunch')">
                                            <v-icon class="mr-2" small>fastfood</v-icon>
                                            Prânzul inclus in preț.
                                        </v-row>
                                        <v-row no-gutters v-if="rate.rate.meals.includes('dinner')">
                                            <v-icon class="mr-2" small>local_dining</v-icon>
                                            Cina inclusă in preț.
                                        </v-row>

                                        <v-row v-if="rate.cancellation_policy.free_cancellation" no-gutters class="success--text">
                                            <v-icon class="mr-2 light-green--text" small>thumb_up_alt</v-icon>
                                            Rambursabil
                                        </v-row>
                                        <template v-else>
                                            <v-row no-gutters class="warning--text">
                                                <v-icon class="mr-2 warning--text" small>error_outline</v-icon>
                                                Nerambursabil
                                            </v-row>
                                            <template v-for="rule in rate.cancellation_policy.rules">
                                                <div class="">
                                                    Penalizari incepand cu data de {{rule.computed.starts_at.split(' ')[0]}} pana la {{rule.computed.ends_at.split(' ')[0]}} in valoare de {{ rule.computed.amount }}{{room.currency}}
                                                </div>
                                            </template>
                                        </template>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="6" class="text-right">
                                <room-count :count="count(index_room,rate)" @bookRoom="bookRoom($event, rate, index_room,index_rate)"></room-count>
                                <v-chip class="ma-1" small dark color="green">Available: {{totalRooms(index_room,rate.inventory_id)}}</v-chip>
                            </v-col>

                        </v-row>
                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>

    </v-card>

</div>
</template>

<script>
import defaultImage from "@/assets/room.jpeg";
import IMPrice from '../utils/IMPrice.vue';
import RoomCount from './RoomCount.vue';

export default {

    components: {
        'im-price': IMPrice,
        'room-count': RoomCount
    },

    props: {
        hotel: {
            type: Object,
            default: () => null
        },
        availability: {
            type: Object,
            default: () => null
        }
    },

    data: () => ({
        image: defaultImage,
        modal: false,
        book_model: [],
        room: null
    }),

    methods: {

        bookRoom(room_count, room, index_room, index_rate) {
            this.$set(this.availability.rooms[index_room].prices[index_rate], 'count', room_count)
            sessionStorage.setItem('availability', JSON.stringify(this.availability));
        },

        count(index_room, rate) {
            let count = 0;
            let array = this.availability.rooms[index_room].prices.filter(item => item.rate_id !== rate.rate_id)
            array.forEach((item, i) => {
                if(item.count) {
                    count += item.count;
                }
            });
            return this.availability.rooms[index_room].inventory[rate.inventory_id].available - count
        },

        totalRooms(index, id) {
            let value = 0;
            this.availability.rooms[index].prices.forEach((item, i) => {
                if(id == item.inventory_id && item.count) {
                    value += item.count
                }
            });
            return Number(this.availability.rooms[index].inventory[id].available) - value
        }

    }

}
</script>
